type CodeNameEntity = { id: number; code: string; name: string };
type CombLevelAccountEntity = { combLevel: string; code: string; name: string };

export const mapCodeNameSelectOption = (item: CodeNameEntity) => ({
  value: item.id,
  label: item.name,
});

export const mapCombLevelSelectOption = (item: CombLevelAccountEntity) => ({
  value: item.combLevel,
  label: item.name,
});
